<template>
  <div>
    <FormItem
      :label="field.label || 'Федеральный округ'"
      :required="required"
      data-testid="citycode__fo"
    >
      <Select
        data-testid="citycode__fo__select"
        :value="value"
        filterable
        clearable
        placeholder="Выберите округ"
        :loading="loading"
        autocomplete="off"
        @change="onSelect"
      >
        <Option
          v-for="(option, i) in foList.raw"
          :key="i"
          data-testid="citycode__fo__option"
          :label="option.value"
          :value="option.id"
        />
        <template #help>
          {{ field.comment || '' }}
        </template>
      </Select>
    </FormItem>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'FO',
  props: {
    value: {
      type: Number,
      required: false,
      default: null,
    },
    field: {
      type: Object,
      required: true,
    },
    required: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      foList: (state) => state.utils.help.fo,
    }),
  },
  methods: {
    onSelect(val) {
      if (!val) {
        val = null;
      }
      this.$emit('change', 'fo', val);
      this.$emit('change', 'city', null);
      this.$emit('change', 'region', null);
    },
  },
};
</script>

<style lang="scss"></style>
